export default "__VITE_ASSET__CM3QilO1__"